import AreaRowPlantel from "./AreaRowPlantel";

const AreasTablePlantel = ({ areas, search }) => {
  return (
    <div className="table-responsive scroll-sm">
      <table className="table bordered-table mb-0" style={{ minWidth: "700px" }}>
        <thead>
          <tr>
            <th scope="col" style={{ minWidth: "60px" }}>ID</th>
            <th scope="col" style={{ minWidth: "250px" }}>Área</th>
            <th scope="col" style={{ minWidth: "100px" }}>Estado</th>
            <th scope="col" style={{ minWidth: "80px" }}>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {areas.map((area) => (
            <AreaRowPlantel key={area.id} area={area} search={search} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AreasTablePlantel;
